<div class="top-section">
    <div class="flex items-center">
        <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
            [color]="ss.theme().color8" *ngIf="!cc.isNarrowScreen()"></app-svg>
        <h4 class="heading mb-0">{{ ss.t('settings_title') }}</h4>
    </div>
    <div class="flex items-center gap-4">
        <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
        <app-svg name="more" class="cursor-pointer" [matMenuTriggerFor]="settingsMenu" role="button"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
        <mat-menu #settingsMenu="matMenu" xPosition="before" class="me-menu">
            <button mat-menu-item (click)="logout()">
                <span class="text-14-400 color-8 flex items-center gap-3">
                    <app-svg name="logout" class="icon-mirror-rtl" [color]="ss.theme().color35"></app-svg>
                    {{ ss.t('account_logoutThisDevice') }}
                </span>
            </button>
            <button mat-menu-item (click)="logoutAllDevices()">
                <span class="text-14-400 color-8 flex items-center gap-3">
                    <app-svg name="logout" class="icon-mirror-rtl" [color]="ss.theme().color35"></app-svg>
                    {{ ss.t('account_logoutAllDevices') }}
                </span>
            </button>
            <button mat-menu-item (click)="deleteAccount()">
                <span class="text-14-400 color-8 flex items-center gap-3">
                    <app-svg name="commonMenutrash" [color]="ss.theme().color11"></app-svg>
                    {{ ss.t('account_deleteAccount') }}
                </span>
            </button>
        </mat-menu>

        <app-svg name="close" role="button" (click)="navigateToToday()"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
    </div>
</div>

<div class="body-section position-relative">
    <!-- Account Section -->
    <div class="account-details-block bg-5">
        <h6 class="text-16-400 color-35 mb-0 ri-px-4 ri-py-3 ri-bb-1 setting-section-header"
            [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null">{{
            ss.t('account_sectionAccountTitle') }}</h6>
        <div class="flex items-center ri-px-4 ri-py-3" (click)="editUserName()" role="button">
            <app-svg name="settingsName" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
            <p class="text-16-400 color-8 mb-0">{{ userStore.name() }}</p>
        </div>
        <div class="flex items-center ri-px-4 ri-py-3">
            <app-svg name="settingsEmail" class="settings-icon ri-me-3" [color]="ss.theme().color7"></app-svg>
            <p class="text-16-400 color-8 mb-0 no-autolink">{{ userStore.email() }}</p>
        </div>
    </div>

    <!-- Subscription Section -->
    <div class="subscription-block bg-5">
        <h6 class="text-16-400 color-35 mb-0 ri-px-4 ri-py-3 ri-bb-1 setting-section-header"
            [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null">{{
            ss.t('account_sectionSubscriptionTitle') }}</h6>
        <div class="flex items-center justify-between ri-px-4 ri-py-3" role="button">
            <div class="flex items-start">
                <app-svg [name]="ss.isPremiumUser() || ss.isInGracePeriod() ? 'crown' : 'settingsSubscriptionInactive'"
                    class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
                <div>
                    <p class="text-16-400 color-8 mb-0">{{ subscriptionPlanName() }}</p>
                    <p class="text-12-400 mb-0 ri-pt-2" *ngIf="subscriptionRenewsOnText()"
                        [class]="ss.effectiveSubscription().eSubscriptionInfo.unsubscribedAt ? 'color-11' : 'color-7'">
                        {{
                        subscriptionRenewsOnText() }}</p>
                    <p class="text-12-400 color-14 mb-0 ri-pt-2" *ngIf="ss.isInGracePeriod()">
                        {{ ss.t('subscription_expired') }}</p>
                    <p class="text-12-400 color-7 mb-0 ri-pt-2"
                        *ngIf="!ss.isInGracePeriod() && subscriptionPlan() === 'free'">
                        {{ ss.t('subscription_noStorageAvailable') }}</p>
                </div>
            </div>
            <a class="text-16-400 color-35 mb-0 block" (click)="openPlans()">{{
                subscriptionButtonText() }}</a>
        </div>
        <div class="ri-px-4 ri-py-3" *ngIf="ss.isPremiumUser() || ss.isInGracePeriod()">
            <div class="flex items-center">
                <app-svg name="settingsMediaStorage" class="settings-icon ri-me-3"
                    [color]="ss.theme().color35"></app-svg>
                <p class="text-16-400 color-8 mb-0 flex-1">{{ ss.t('account_subscriptionMediaStorage') }}</p>
                <p class="text-14-400 mb-0">
                    <span dir="ltr">
                        <span [class]="ss.isInGracePeriod() ? 'color-14' : 'color-35'">{{ userStore.storageUsed() |
                            parseBytes }}</span>
                        <span class="color-7"> / {{ effectiveStorageLimit() | parseBytes }}</span>
                    </span>
                </p>
            </div>
            <div class="ri-pt-2 media-storage-indent">
                <div class="progress-bar-container">
                    <div class="progress-bar" [style.width.%]="storageUsedPercentage()"
                        [class.progress-bar-full]="storageUsedPercentage() >= 100"
                        [class.progress-bar-grace]="ss.isInGracePeriod()"></div>
                </div>
                <!-- Attachments chips -->
                <div class="ri-pt-2 flex items-center gap-2 flex-wrap">
                    <span class="attachments-chip" [class.grace]="ss.isInGracePeriod()"
                        (click)="openAttachmentsGallery()" role="button">
                        <app-svg name="attachment" [color]="ss.theme().color8"
                            style="width: 14px; height: 14px;"></app-svg>
                        <span class="text-12-400 color-8">{{ userStore.storageUsed() | parseBytes }}</span>
                    </span>
                    <span class="attachments-chip" [class.grace]="ss.isInGracePeriod()"
                        (click)="openMessageAttachmentsBrowser()" role="button">
                        <app-svg name="messages" [color]="ss.theme().color8"
                            style="width: 14px; height: 14px;"></app-svg>
                        <span class="text-12-400 color-8">{{ ss.t('message_attachments') }}</span>
                    </span>
                </div>
                <p class="text-12-400 color-14 mb-0 ri-pt-2" *ngIf="ss.isInGracePeriod()">
                    {{ gracePeriodDaysRemaining() }}
                </p>
            </div>
        </div>
    </div>

    <!-- Experience Section -->
    <div class="app-experience bg-5">
        <h6 class="text-16-400 color-35 mb-0 ri-px-4 ri-py-3 ri-bb-1 setting-section-header"
            [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null">{{
            ss.t('settings_sectionExperienceTitle') }}</h6>
        <div class="flex items-center justify-between ri-px-4 ri-py-3">
            <div class="flex items-center">
                <app-svg name="settingsTheme" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
                <p class="text-16-400 color-8 mb-0">{{ ss.t('common_theme') }}</p>
            </div>
            <app-kebab-show-menu [signal]="ss.viewSignals()['appTheme']" name="appTheme" [config]="appThemeConfig()"
                [selectedMark]="'TICK'" (select)="updateTheme()" textClass="text-16-400"></app-kebab-show-menu>
        </div>
        <div class="flex items-center justify-between ri-px-4 ri-py-3">
            <div class="flex items-center">
                <app-svg name="settingsColor" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
                <p class="text-16-400 color-8 mb-0">{{ ss.t('settings_experienceColour') }}</p>
            </div>
            <app-svg name="appSettingColor" class="cursor-pointer" (click)="openThemeDialog()"></app-svg>
        </div>
        <div class="flex items-center justify-between ri-px-4 ri-py-3" role="button" (click)="ss.openLanguageDialog()">
            <div class="flex items-center">
                <app-svg name="settingsLanguage" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
                <p class="text-16-400 color-8 mb-0">{{ ss.t('common_language') }}</p>
            </div>
            <p class="text-16-400 color-35 mb-0">{{ ss.languageDisplayInfo()[ss.appLanguageCode()]?.nativeName ||
                cc.languageMap[ss.appLanguageCode()].name }}</p>
        </div>
        <div class="flex items-center justify-between ri-px-4 ri-py-3" role="button"
            (click)="ss.openWeekStartDayDialog()">
            <div class="flex items-center">
                <app-svg name="calendar" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
                <p class="text-16-400 color-8 mb-0">{{ ss.t('settings_weekStartDay') }}</p>
            </div>
            <p class="text-16-400 color-35 mb-0">{{ weekStartDayLabel() }}</p>
        </div>
    </div>

    <!-- Data Section -->
    <div class="data-block bg-5">
        <h6 class="text-16-400 color-35 mb-0 ri-px-4 ri-py-3 ri-bb-1 setting-section-header"
            [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null">{{
            ss.t('account_sectionDataTitle') }}</h6>
        <div class="flex items-center justify-between ri-px-4 ri-py-3" role="button" (click)="backupData()">
            <div class="flex items-center flex-1">
                <app-svg name="settingsBackupData" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
                <div>
                    <p class="text-16-400 color-8 mb-0">{{ ss.t('account_backupData') }}</p>
                    <p class="text-12-400 color-7 mb-0 ri-pt-2" *ngIf="userStore.exportLastUpdatedAt()">{{
                        backupDateText() }}</p>
                </div>
            </div>
            @if (userStore.exportStatus() === 'inProgress') {
            <div class="activity-label">
                <span class="text-12-400 color-35 inProgress-text">{{ ss.t('account_inProgress') }}</span>
            </div>
            }
        </div>
        <div class="flex items-center ri-px-4 ri-py-3" role="button" (click)="deleteData()">
            <app-svg name="settingsDeleteData" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
            <p class="text-16-400 color-8 mb-0">{{ ss.t('account_deleteData') }}</p>
        </div>
        <div class="flex items-center ri-px-4 ri-py-3" role="button" (click)="importData()">
            <app-svg name="settingsImportData" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
            <p class="text-16-400 color-8 mb-0">{{ ss.t('common_importData') }}</p>
        </div>
        <input #importBackupFileInput type="file" id="importBackupFile" class="form-control hidden"
            accept="application/zip" (change)="importFile($event)">
    </div>

    <!-- About Section -->
    <div class="about-block bg-5">
        <h6 class="text-16-400 color-35 mb-0 ri-px-4 ri-py-3 ri-bb-1 setting-section-header"
            [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null">
            {{ ss.t('common_about') }}
        </h6>
        <div class="flex items-center ri-px-4 ri-py-3" role="button" (click)="openVersionDetails()">
            <app-svg name="settingsVersionDetail" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
            <p class="text-16-400 color-8 mb-0">{{ ss.t('common_version') }}</p>
        </div>
        <div class="flex items-center ri-px-4 ri-py-3" role="button" (click)="openLegal()">
            <app-svg name="settingsLegal" class="settings-icon ri-me-3" [color]="ss.theme().color35"></app-svg>
            <p class="text-16-400 color-8 mb-0">{{ ss.t('account_legal') }}</p>
        </div>
    </div>
</div>